/**
 * Whether a keyboard event's target is a text-entry surface — single-key
 * shortcuts (G/E, palette toggles) must never fire while the user types.
 */
export const isTextEntryTarget = (target: EventTarget | null): boolean => {
  if (!(target instanceof HTMLElement)) return false;
  const tag = target.tagName;
  return (
    tag === 'INPUT' ||
    tag === 'TEXTAREA' ||
    tag === 'SELECT' ||
    target.isContentEditable
  );
};
